<sdps-divider variation="secondary"></sdps-divider>
<div id="section-title">{{sectionTitle}}</div>
<div class="row">
    <div class="column">
        <mm-condensed-label-group id="checkCondensed_transactionType" [title]="labels.transactionType" [data]="transactionType"></mm-condensed-label-group>
    </div>
    <div class="column" *ngIf="useStandingAuth && !isPendingSloaSetup">
        <mm-condensed-label-group id="checkCondensed_useStandingAuth" [title]="labels.useStandingAuth"
            [data]="useStandingAuth | titlecase">
        </mm-condensed-label-group>
    </div>
    <div class="column" *ngIf="shouldShowStandingAuthFields()">
        <mm-condensed-label-group id="check_standingAuthDetails" data-testid="checkDetails_standingAuthDetails"
            [title]="isBsloaTransaction ? labels.bundledStandingAuthDetails : labels.standingAuthDetails"
            [multilineData]="standingAuthDetailsLines">
        </mm-condensed-label-group>
    </div>
    <div class="column" *ngIf="frequency">
        <mm-condensed-label-group id="checkCondensed_frequency" [title]="labels.frequency" [data]="frequency"></mm-condensed-label-group>
    </div>
    <div *ngIf="isRecurringTransaction" class="column" data-testid="check_frequencyRecurringTransfer">
        <mm-condensed-label-group id="checkCondensed_frequencyRecurringTransfer" [title]="labels.frequencyOfRecurringTransfer" [data]="frequencyOfRecurringTransfer"></mm-condensed-label-group>
    </div>
    <div class="column">
        <mm-condensed-label-group id="checkCondensed_processDate" [title]="labels.processDate" [data]="processDate | formattedDate"></mm-condensed-label-group>
    </div>
    <div *ngIf="secondProcessDate" class="column" data-testid="check_secondProcessDate">
        <mm-condensed-label-group id="checkCondensed_secondProcessDate" [title]="labels.secondProcessDate" [data]="secondProcessDate | formattedDate"></mm-condensed-label-group>
    </div>
    <div *ngIf="nextProcessDate" class="column" id="checkCondensed_nextProcessDate" data-testid="check_nextProcessDate">
        <mm-condensed-label-group id="checkCondensed_nextProcessDate" [title]="labels.nextProcessDate" [data]="nextProcessDate | formattedDate"></mm-condensed-label-group>
    </div>
    <div *ngIf="endDate" class="column" data-testid="check_endDate">
        <mm-condensed-label-group id="checkCondensed_endDate" [title]="labels.endDate" [data]="endDate | formattedDate"></mm-condensed-label-group>
    </div>
    <div class="column">
        <mm-condensed-label-group id="checkCondensed_payee" [title]="labels.payee" [data]="payee"></mm-condensed-label-group>
    </div>
    <div class="column">
        <mm-condensed-label-group id="checkCondensed_amount" [title]="labels.amount" [data]="amount"></mm-condensed-label-group>
    </div>
    <div *ngIf="hasCheckNumberForCompletedTransaction" class="column">
        <mm-condensed-label-group id="checkCondensed_number" [title]="labels.checkNumber" [data]="checkNumber"></mm-condensed-label-group>
    </div>
    <div *ngIf="isIraTransaction" class="column" data-testid="check_grossNet">
        <mm-condensed-label-group id="checkCondensed_grossNet" [title]="labels.grossNet" [data]="grossNet | titlecase"></mm-condensed-label-group>
    </div>
    <div *ngIf="isIraTransaction" class="column" [attr.data-testid]="isOneTimeTotalDist || isBundledOneTimeTotalDist ? 'check_withdrawalAmount' : 'check_netCashAmount'">
        <mm-condensed-label-group
            [id]="isOneTimeTotalDist || isBundledOneTimeTotalDist ? 'checkCondensed_withdrawalAmount' : 'checkCondensed_netCashAmount'"
            [title]="isOneTimeTotalDist || isBundledOneTimeTotalDist ? labels.totalWithdrawalAmountCheck : labels.netCashAmount"
            [data]="isOneTimeTotalDist || isBundledOneTimeTotalDist ? totalWithdrawalAmount : netCashAmount">
        </mm-condensed-label-group>
    </div>
    <div *ngIf=!isRecurringTransaction class="column" data-testid="check_deliveryMethod">
        <mm-condensed-label-group id="checkCondensed_deliveryMethod" [title]="labels.deliveryMethod" [data]="deliveryMethod"></mm-condensed-label-group>
    </div>
    <div *ngIf="checkReason" class="column" data-testid="check_checkReason">
        <mm-condensed-label-group id="checkCondensed_checkReason" [title]="labels.checkReason" [data]="checkReason | sentenceCase"></mm-condensed-label-group>
    </div>
    <div class="column" *ngIf="showPayIncome" data-testid="check_payIncome">
        <mm-condensed-label-group id="checkCondensed_payIncome" [title]="labels.payIncome" [data]="payIncome | titlecase"></mm-condensed-label-group>
    </div>
    <div class="column">
      <mm-condensed-label-group *ngIf="isOneTimeTotalDist && closeAccount === 'Yes'" id="check_closeAccount" data-testid="check_closeAccount" 
        [title]="labels.closeAccount" 
        [data]="closeAccount"
        class="close-account-column">
      </mm-condensed-label-group>
    </div>
    <div class="column check_reportsRequestedSection" *ngIf="reportsRequested.length > 0">
      <mm-condensed-label-group *ngIf="isOneTimeTotalDist && closeAccount === 'Yes'" id="check_reportsRequested" data-testid="check_reportsRequested" 
        [title]="labels.reportsRequested" 
        [multilineData]="reportsRequested"
        class="reports-requested-column">
      </mm-condensed-label-group>
      <mm-tooltip *ngIf="isOneTimeTotalDist && closeAccount === 'Yes'" [position]="'right'" [containsLink]="false" id="reports-requested-tooltip" data-testid="reports-requested-tooltip">
        <tooltip-content>
          <div>{{reportsRequestedTooltip}}</div>
        </tooltip-content>
        <tooltip-trigger-element>
          <sdps-icon color="active" type="functional" name="info" size="small"></sdps-icon>
        </tooltip-trigger-element>
      </mm-tooltip>
    </div>
</div>
<div id="process-date-copy">{{processDateCopy}}</div>
